/* lystia-pdp-head.js - голова PDP (T-E4-03). Підключення: <script src="{{ 'lystia-pdp-head.js' | asset_url }}" defer> (snippets/pdp-head.liquid).
   1) share: navigator.share({title, url}) або clipboard -> тост «Посилання скопійовано» / «Не вдалося скопіювати» (url = location.href без ?query).
   2) ♥ (D у рядку рейтингу; M на галереї - E4-02): тоггл робить lystia-favorites.js ([data-fav-toggle][data-handle]); тут лише тост на fav:change від кліку
      по .pdp__fav / [data-fav-toggle] всередині [data-pdp]. Тексти - з data-* на [data-pdp-acts] (locales).
   3) ціна: подія document `variant:change` { detail: { price, compareAt } } (копійки; шле T-E4-04) -> tweenNum 320мс, ease-out cubic (1-(1-k)^3), .is-bump;
      стара ціна показується/ховається; aria-live=polite на [data-pdp-price]. Формат числа як snippets/price.liquid (NBSP як роздільник тисяч, символ валюти береться з поточного тексту). */
(function () {
  'use strict';
  if (window.LystiaPdpHead) return;

  var NBSP = ' ';
  var TWEEN_MS = 320;

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function toast(text, opts) {
    if (text && document.lystiaToast) document.lystiaToast.show(text, opts || {});
  }

  function acts(from) {
    var root = from && from.closest ? from.closest('[data-pdp]') : null;
    return (root || document).querySelector('[data-pdp-acts]');
  }

  /* ---------- share ---------- */
  function share(btn) {
    var box = acts(btn);
    var d = box ? box.dataset : {};
    var url = location.href.split('?')[0].split('#')[0];
    if (navigator.share) {
      navigator.share({ title: btn.getAttribute('data-title') || document.title, url: url }).catch(function () {});
      return;
    }
    var fail = function () { toast(d.textCopyFailed, { icon: 'alert' }); };
    try {
      navigator.clipboard.writeText(url).then(function () { toast(d.textLinkCopied, { icon: 'check' }); }, fail);
    } catch (e) { fail(); }
  }

  /* ---------- ціна ---------- */
  function fmtRub(v, cur) {
    var s = String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
    return s + NBSP + cur;
  }

  function fmt(cents, cur) { return fmtRub(cents / 100, cur); }

  function bump(el) {
    el.classList.remove('is-bump');
    void el.offsetWidth;
    el.classList.add('is-bump');
  }

  function tween(el, from, to, cur) {
    if (el._lysTween) { clearTimeout(el._lysTween); el._lysTween = null; }
    if (from === to || reduced()) { el.textContent = fmtRub(to, cur); return; }
    var t0 = performance.now();
    bump(el);
    function step(t) {
      var k = Math.min(1, (t - t0) / TWEEN_MS);
      var e = 1 - Math.pow(1 - k, 3);
      el.textContent = fmtRub(from + (to - from) * e, cur);
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
    /* фонові вкладки без rAF */
    el._lysTween = setTimeout(function () { el.textContent = fmtRub(to, cur); }, TWEEN_MS + 60);
  }

  function onVariant(e) {
    var d = e.detail || {};
    if (typeof d.price !== 'number') return;
    document.querySelectorAll('[data-pdp-price]').forEach(function (box) {
      var now = box.querySelector('.lprice__now');
      if (!now) return;
      var m = now.textContent.match(/[^\d\s ]+$/);
      var cur = m ? m[0] : '';
      var prev = parseInt(now.textContent.replace(/\D/g, ''), 10);
      if (now._lysTo != null) prev = now._lysTo;
      now._lysTo = Math.round(d.price / 100);
      tween(now, isNaN(prev) ? now._lysTo : prev, now._lysTo, cur);
      var old = box.querySelector('.lprice__old');
      var wrap = box.querySelector('.lprice');
      if (typeof d.compareAt === 'number' && d.compareAt > d.price) {
        if (!old && wrap) {
          old = document.createElement('s');
          old.className = 'lprice__old strike';
          wrap.appendChild(old);
        }
        if (old) old.textContent = fmt(d.compareAt, cur);
      } else if (old) {
        old.remove();
      }
      var meta = box.querySelector('[data-pdp-price-meta]');
      if (meta) bump(meta);
    });
  }

  /* ---------- ♥: тост ---------- */
  var pendingFav = null;
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var fav = t.closest('[data-pdp] .pdp__fav, [data-pdp] [data-fav-toggle]');
    if (fav) { pendingFav = fav; return; }
    var sh = t.closest('[data-pdp-share]');
    if (sh) share(sh);
  }, true);

  document.addEventListener('fav:change', function (e) {
    var btn = pendingFav;
    pendingFav = null;
    if (!btn || !e.detail || e.detail.reason !== 'toggle') return;
    var box = acts(btn);
    if (!box) return;
    var d = box.dataset, on = !!e.detail.active;
    toast(on ? d.textFavAdded : d.textFavRemoved, {
      icon: on ? 'heart-fill' : 'heart',
      action: on && d.favUrl ? { label: d.textView, href: d.favUrl } : null
    });
  });

  document.addEventListener('variant:change', onVariant);

  window.LystiaPdpHead = Object.freeze({ fmt: fmt });
})();
